<template>
  <div>
    <app-loader v-show="$store.state.appConfig.showLoader" />
    <div class="mobileWrapper consentPageBg">
      <b-row>
        <b-col cols="12">
          <div class="myInfo">
            <div class="rtr-Icon">
              <span>
                <img :src="assignmentImg">
              </span>
            </div>
            <div class="rtrInfoContent">
              <h2>Retrieve your details</h2>
              <p>Please note that retrieving information through Singpass MyInfo is mandatory to proceed with the new purchaser’s details form.</p>
              <!-- <div class="singpass-btn-cs floatCss">
                <b-button
                  class="sbs-btn"
                  @click="singpassLogin"
                >
                  Retrieve Myinfo with <b-img
                    :src="singPassLogo"
                    height="28"
                  />
                </b-button>
              </div> -->
              <div class="singpass-button-img singpass-btn-cs floatCss">
                <b-img
                  :src="singPassButton"
                  class="cursor-pointer"
                  @click="singpassLogin"
                />
              </div>
              <div class="singpass-btn-cs floatCss">
                <b-button
                  class="sbs-cancel-btn"
                  @click="$router.go(-1)"
                >
                  Cancel
                </b-button>
              </div>
            </div>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <div class="Singpass-bottom-info floatCss">
            <p>If you don’t have Singpass, you can visit the Nirvana Customer Service Counter at our premises for assistance by one of our
              Customer Service officers.</p>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import {
  BRow, BCol, BButton, BImg,
} from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import AppLoader from '../AppLoader.vue'

export default {
  components: {
    BRow,
    BCol,
    BButton,
    BImg,
    AppLoader,
  },
  data() {
    return {
      // eslint-disable-next-line global-require
      logoImg: require('@/assets/images/frontend/logo-slim.png'),
      // eslint-disable-next-line global-require
      assignmentImg: require('@/assets/images/file-transfer/assignment_ind.svg'),
      // eslint-disable-next-line global-require
      errorIcon: require('@/assets/images/file-transfer/error-icon.svg'),
      // eslint-disable-next-line global-require
      singPassButton: require('@/assets/images/frontend/singpass.png'),
    }
  },
  methods: {
    singpassLogin() {
      localStorage.setItem('fileTransferToken', this.$route.params.token)
      const formData = new FormData()
      formData.append('purpose', 'file-transfer-purchaser')

      this.$http.post('front-end/singpass/file-transfer/purchaser', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      })
        .then(response => {
          localStorage.setItem('singpassAuthorizationSession', response.data.sessionID)
          // console.log(response.data.authorizationUrl)
          window.location.href = response.data.authorizationUrl
        })
        .catch(error => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: error.data.message || process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        })
    },
  },
}
</script>
